/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Standard Drive Cycles.
 */
export enum StandardDriveCycles {
    WLTP3 = 'WLTP3',
    US06 = 'US06',
    UDDS = 'UDDS',
    HWFET = 'HWFET',
}
